import React from 'react';
import { RefreshCw } from 'lucide-react';
import { isWhiteLabel } from '../../config/tenantConfig';

interface LoadingSpinnerProps {
  message?: string;
  size?: number | 'sm' | 'md' | 'lg';
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message = 'Loading...',
  size = 'md'
}) => {
  const wl = isWhiteLabel();
  const getSize = () => {
    if (typeof size === 'string') {
      switch (size) {
        case 'sm': return 24;
        case 'md': return 40;
        case 'lg': return 56;
        default: return 24;
      }
    }
    return size;
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-[200px] gap-2">
      <RefreshCw className={`animate-spin ${wl ? 'text-zebu-600' : 'text-blue-600'}`} size={getSize()} />
      {message && (
        <p className="text-sm text-gray-500 dark:text-gray-400">
          {message}
        </p>
      )}
    </div>
  );
};

export default LoadingSpinner;